import {
	SET_LISTING_DATA,
	SET_SEARCH_DATA,
	SET_ACTION_CARD_DATA,
	EMPTY_SEARCH_DATA,
	UPDATE_PRODUCT_PRICE,
	UPDATE_PRODUCT_SELLING_PRICE,
	DELETE_PRODUCT,
	EDIT_PRODUCT,
	EDIT_ENRICH_PRODUCT,
	UPDATE_EDIT_PRODUCT_DETAIL,
	UPDATE_PRODUCT_IMAGE,
	TOGGLE_EDIT_IMAGE_OPTIONS,
	DELETE_PRODUCT_IMAGE,
	SET_CURRENT_EDIT_PAGE,
	PRODUCTSCORE,
	PRODUCT_UNDER_EDIT,
	SAVE_ADD_EDIT_PRODUCT,
	RESET_PRODUCT_DATA,
	INIT_ADD_PRODUCT,
	SHOW_PRODUCT_EDIT_SLIDER,
	SHOW_HIDE_EDIT_OPTION,
	HIDE_PRODUCT_EDIT_SLIDER,
	HIDE_ITEM_SEARCH_SLIDER,
	SHOW_ITEM_SEARCH_SLIDER,
	SHOW_NOT_FOUND_MODAL,
	HIDE_NOT_FOUND_MODAL,
	IS_PRODUCT_UPDATED,
	RESET_LISTING_DATA,
	LISTING_FILTER,
	RESET_RESULT_DATA,
	UPDATE_IMAGES_BEING_UPLOADED,
	SET_APP_CAT_COV_USER,
	SET_APPROVAL_PENDING,
	SET_DELETION_PENDING,
	SET_PRODUCT_CONFLICT,
	TOGGLE_PROD_CONFLICT,
	SET_BRAND_PROD_SELECTION,
	SET_TAB_STATUS,
	SETPSVINFODATA,
	GET_BIZ,
	UPDATE_BIZ,
	TOGGLE_BIZ,
	TOGGLE_PRODUCT_VISIBILITY,
	UPDATE_PRODUCT_VIDEO,
	UPDATE_VIDEO_ID_PRODUCT,
	LINK_VIDEO_TO_PRODUCT,
	SET_PRODUCT_SPECIFICATION,
	UNLINK_VIDEO,
	UPLOAD_YOUTUBE_VIDEO,
	DISCARD_ADD_PRODUCT_MEDIA,
	UPLOAD_IMAGE_FROM_LINK,
	SET_ATTACHMENT_DATA,
	DELETE_ATTACHMENT_FILE,
	TOGGLE_EDIT_DISPLAYNAME_MODAL,
	RENAME_PRODUCT_ATTACHMENT,
	VIEW_FILE_DETAILS_SLIDER,
	TOGGLE_FILE_PROGRESS_BAR,
	CANCEL_PENDING_FILES,
	MARK_PREVIOUSLY_UPLOADED_FILES,
	SET_AUDIT_OBJECT,
	HIDE_TOAST_MESSAGE_LOCAL,
	RESTORE_PRODUCT_DATA,
	SHOW_TOAST_MESSAGE_LOCAL,
	TOGGLE_CONFIRM_DELETE,
	TOGGLE_CONFIRM_APPROVE,
	TOGGLE_TAB,
	SET_ATTACHMENT_DATA_VENDOR,
	REDIRECTED_FROM,
	TOGGLE_INFO_BOX,
	TOGGLE_ADD_PRODUCT_SLIDER,
	TOGGLE_ADD_EDIT_BUTTON_ANIMATION,
	FROM_EDIT_PRODUCT_SLIDER,
	TOGGLE_SEARCH_SLIDER,
	TOGGLE_ACTION_CARD_SLIDER,
	TOGGLE_SUPPORT_SLIDER,
	ACTION_CARD_FILTER,
	RELOAD_ACTION_CARD_SLIDER,
	FILE_ATTACHMENT_PERMISSION,
	RESET_FILE_ATTACHMENT_DATA,
	SET_VENDOR_IMAGES,
	SET_PRODUCT_SLIDER_DATA,
	UPLOAD_MULTIPLE_IMAGES,
	SET_OBJECTIONAL_PENDING,
	SET_BRAND_PENDING,
	SET_VENDOR_OBJECTIONABLE_PRODUCTS,
	SET_GENERIC_DELETION_PENDING,
	INITIAL_COUNTRY_CODE,
	SET_SELECTED_CATEGORY,
	SET_AUDIT_PENDING,
	SET_REJECTED_PRODUCTS,
	SET_BRAND_SUGGESTION,
	SET_QUEUE_TYPE,
	SET_SMART_FILL_DATA,
	SET_AUDITOR_BRANDED_LOG,
	SET_SEARCH_BY_DOC_ID,
	SET_VIA_SUGGESTED,
	SET_FROM_SELLER,
	SET_SUGGESTED_VIA_SEARCH,
	SET_SHOULD_RETAIN,
	SET_PREVIOUS_TAB_INDEX,
	UPDATE_FIXED_SPECS,
	DELETE_IMAGE_FROM_ADD_EDIT,
	UPLOAD_IMAGE_FROM_ADD_EDIT,
	UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT,
	REMOVE_VIDEO_FROM_ADD_EDIT,
	UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT,
	SAVE_REJECTED_VIA_AUDIT,
	TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER,
	TOGGLE_BROCHURE_EDITNAME_DIALOG,
	TOGGLE_BROCHURE_FILE_PREVIEW,
	SET_BROCHURE_DATA,
	BROCHURE_TOTAL_FILES_UPLOAD,
	BROCHURE_TOTAL_FILES_ERROR,
	BROCHURE_FILES_RESET_DATA,
	BROCHURE_SUCCESS_FILE_UPLOAD,
	BROCHURE_TEMP_ACTIVE_TAB,
	BROCHURE_LISTING_COUNT,
	BROCHURE_LISTING_DATA,
	TOGGLE_PRODUCT_CARD_SLIDER,
	PRICE_CARD_DATA_FETCHED,
	PENDING_TABS,
	PAUSE_APPROVAL_REDIRECT,
	TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER,
	OUTDATED_PRICE_CARD_DATA_FETCHED,
	TOGGLE_CATEGORY_MISSING_CARD_SLIDER,
	CATEGORY_MISSING_DATA_FETCHED,
	TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST,
	DELETE_VIDEO_URL_ID_ALL_PRODUCTS,
	UPDATE_DESC_TYPE,
	TOGGLE_AI_CREATION_MODAL
} from '../actions/types';
import config from '../../config/config';
import { updateProductMediaService, restoreProductDataReq } from '../common/productImageUtils';
import { objectionalKeyHandling } from "../utills";
const staticImageDomains = config.staticImageDomains;
const initialListingObj = {
	results: [],
	companyDetails: {},
	currentPage: 1,
	filterObj: {},
	headerData: {},
	newTabClicked: false,
	showNoProdPage: false
}
const initialProductListObj = {
	results: [],
	currentPage: 1
}
const initialState = {
	allProducts: {
		ADD_PRODUCT: {
			imageUrlArr: [],
			videoUrlIds: []
		}
	},
	allEnrichProducts: {},
	listing: initialListingObj,
	filterProductObj : {},
	search: {
		results: [],
		searchQuery: '',
		searchTab: '',
	},
	actionCardData: {
		results: [],
		filterQuery:''
	},
	productList: initialProductListObj,
	isAddEditButtonAnimation: true,
	isAddProductSlider: false,
	fromEditProductService:false,
	isSearchSliderOpen: false,
	isActionCardSliderOpen:false,
	actionCardFilter : {
		cardName: '',
		filterQuery: '',
		type: ''
	},
	isReloadCardSlider: false,
	imagesBeingUploaded: [],
	isUserApprovedForCatCoverage: true,
	initialRespRejectAudit : '',
	editProduct: null,
	enrichProduct: null,
	currentEditPage: 'listing',
	editImageOptions: null,
	productUnderEdit: {},
	uploadedFileModalData: {},
	showAddEditProduct:false,
	showEnrichEditProduct:false,
	showItemSearch: false,
	showItemSearchProdSer: 'product',
	showEditOptions: false,
	showAddPriceTag: false,
	showOutDatedPriceTag: false,
	fileAttachmentData: {
		currentFile: {},
		showViewDetailsSlider: false,
		showProgressBar: false,
		permissionData: {}
	},
	approvalPendingList: [],
	productConflictList: [],
	auditPendingList: [],
	objectionalAuditPendingList: [],
	rejectedList: [],
	deletionPendingList: [],
	brandSelDesel: {
		list: {},
		showActive: false,
		showDeactive: false,
		activateCount: 0,
		deactivateCount: 0,
		changedList: [],
	},
	objectionableList: [],
	brandList: [],
	genericDeletionList: [],
	confirmDeleteModal: false,
	isToggleTab: false,
	showInfoBox: true,
	auditData: {
		textAreaValue: '',
		checkedValue: ''
	},
	undoInfo: null,
	vendorImages: null,
	jdGalleryImages: null,
	vendorObjectionableProducts: [],
	countryList: [],
	mrpcomplianceList: [],
	selectedCategoryType: 'product',
	queueType: '',
	smartFillData: [],
	auditorBrandedLog : [],
	docIdSearch: false,
	fromSellerDashboard: false,
	tabIndex : 0,
	isActiveBrochure: false,
	brochureAttachment: {
		uploadingFiles: [],
		showUploadHistorySlider: false,
		uploadHistory:{
			totalFiles: 0,
			totalErrors: 0,
			totalSuccess: 0,
		},
		uploadProgress: 0,
		editNameDialog: false,
		previewFile: {
			fileMimeType: 'jpg',
			filePreviewToggle: false
		},
		uploadHistoryFiles: [],
		fileAttachments: [],
		auditPendingCount: 0,
		latestDtTmoFAuditPending: ''
	},
	pricecardData: null,
	pendingTabs: [],
	pauseApprovalRedirect: false,
	outDatedPricecardData: [],
	showCategoryMissingCard: false,
	categoryMissingCardData: [],
	showCategoryMissingCardPersist: false,
	showSupportSlider: false,
	psvInfoData: {},
	psvUomUnits: {},
	showAICreationModal: {
		successModal: {show: false},
		brochureUploadModal: {show: false}
	}
};

const formatAttributes = (attributes = []) => {
	attributes.forEach((cur) => {
		if (['FREETEXT'].indexOf(cur.type) == -1 && cur.options && cur.options.indexOf("other") == -1) {
			cur.options.push("other")
		}
	})
}

const getIndexOf = (results, variantId) => {
	return results.findIndex(product => product.variantId == variantId);
};
const getUploadKeyIndex = (arr, key) => {
	var keyIndex = -1;
	keyIndex = arr.findIndex(cur => key === cur.imgIndex);
	return keyIndex;
};
const getCurrentLocalProduct = (localProduct, product, videos) => {
	let allImagesUploaded = true;
	let allVideosUploaded = true;
	localProduct &&
		localProduct?.imageUrlArr?.map((curImage, index) => {
			if (curImage.uploaded && curImage.base64Url) {
				delete localProduct.imageUrlArr[index].base64Url;
			} else if (!curImage.uploaded) {
				allImagesUploaded = false;
			}
		});
	if (localProduct && localProduct.videoUrlIds && videos) {
		localProduct.videoUrlIds = localProduct.videoUrlIds.reduce((arr, id) => {
			const curVideo = videos[id];
			if (!curVideo) {
				return arr;
			}

			if (!curVideo.uploaded) {
				allVideosUploaded = false;
			}

			arr.push(id);
			return arr;
		}, []);
	}
	if (localProduct) {
		const returnObj = {
			...product,
		}
		if (!allImagesUploaded) {
			returnObj.imageUrlArr = localProduct.imageUrlArr
		}
		if (!allVideosUploaded) {
			returnObj.videoUrlIds = localProduct.videoUrlIds;
		}
		return returnObj;
	} else {
		return {
			...product
		};
	}
};
export default (state = initialState, action) => {
	const payload = action.payload;

	switch (action.type) {
		case SET_LISTING_DATA: {
			if (payload?.checkDoubleClick && payload.tabKey!=state.tabKey) {
				const listing = {
					...state.listing,
					newTabClicked: true
				};
				return {
					...state,
					listing
				};
			}else if(payload?.forShimmer) {
				const listing = {
					...state.listing,
					showShimmer: payload?.showShimmer || false,
					currentPage: typeof payload?.currentPage != 'undefined' ? payload?.currentPage : state.listing.currentPage 
				}
				return {
					...state,
					listing
				}
			}
			const oldResults =
				payload.isReset || payload.currentPage === 1
					? []
					: state.listing.results;

			let allProducts = state.allProducts;
			let brochureAttachment = state.brochureAttachment;
			payload?.productData?.map((product, index) => {
				if (product.isObjectionable || payload.tabKey == "objectionable" || product.id) {
					if (product.productId) {
						product.productId = objectionalKeyHandling({
							key: 'ADD',
							value: product.productId,
							id: product.id
						});
					} else {
						product.productId = objectionalKeyHandling({
							key: 'ADD',
							value: '',
							id: product.id
						});
					}
				}
				const curLocalPRoduct = allProducts[product.productId] || product;
				allProducts[product.productId] = getCurrentLocalProduct(
					curLocalPRoduct,
					product,
					payload.videos
				);
				payload.productData[index] = {
					productId: product.productId,
					attachmentPresent: product.attachmentPresent
				};				
			});
			let allResultsFetched = payload.tabKey == 'auditPending' ? oldResults.concat(payload?.productData).length == payload.totalCount : payload?.productData?.length < 25;
			const listing = {
				currentPage: payload.currentPage,
				prodCount: payload?.productData?.length,
				actualProdCount: payload?.totalActive,
				totalActiveLbl: payload?.totalActiveLbl || '',
				results: oldResults.concat(payload?.productData),
				companyDetails: payload.companyDetails || {},
				isSpecialContractJd: payload.isSpecialContractJd,
				filterObj: payload.filterObj || {},
				allResultsFetched,
				approvalPendingCount: payload.tabKey == 'productConflict'?state.listing.approvalPendingCount:payload.approvalPendingCount,
				productConflictCount: payload.isReadOnly? 0: payload.barcodeConflictCount,
				auditPendingCount: payload.tabKey == 'productConflict'?state.listing.auditPendingCount:payload.auditPendingCount,
				rejectedCount:payload.tabKey == 'productConflict'?state.listing.rejectedCount:payload.rejectedCount,
				rejectedCountLbl: payload?.rejectedCountLbl || '', 
				deletionPendingCount: payload.tabKey == 'productConflict'?state.listing.deletionPendingCount:payload.deletionPendingCount,
				isIneligibleDocid: payload.isIneligibleDocid,
				brandedProductsCount: payload.brandedProductsCount,
				objectionableApprovalPendingCount: payload.tabKey == 'productConflict'?state.listing.objectionableApprovalPendingCount:payload.objectionableApprovalPendingCount,
				objectionableTotalCount: payload.tabKey == 'productConflict'?state.listing.objectionableTotalCount:payload.objectionableTotalCount,
				suggestedProductsCount: payload.tabKey == 'productConflict'?state.listing.suggestedProductsCount:payload.suggestedProductsCount,
				documentPendingCount : payload.tabKey == 'productConflict'?state.listing.documentPendingCount:payload.documentPendingCount,
				documentUploadLink: payload.tabKey == 'documentPending' ? payload.documentUploadLink : '',
				inventoryComplianceCount: payload.tabKey === 'productConflict' ? state.listing.inventoryComplianceCount : payload.inventoryComplianceCount,
				totalBrochureCount: payload?.totalBrochureCount,
				totalActive: payload?.totalActive || 0,
				brochureData: payload?.brochureData || [],
				newTabClicked: false,
				showShimmer: payload?.showShimmer || false,
				showNoProdPage: !payload.tabKey ? true : false
			};
			if (payload && payload.headerData) {
				listing.headerData = payload.headerData;
			}
			if (!payload.keepAddProd) {
				allProducts.ADD_PRODUCT = {
					imageUrlArr: [],
					videoUrlIds: []
				}
			}
			if ((state.listing?.actualProdCount && state.listing.actualProdCount!=1) && !state.isAddEditButtonAnimation) {
				state.isAddEditButtonAnimation = true 
			}
			if(payload.brochureData) {
				const contractorTypes = ["CONTRACTOR", "CONTRACTORV2"];
				const isContractor = payload?.loggedUser ? (contractorTypes.indexOf(payload?.loggedUser?.subType) != -1) : false
				let latestDtTmoFAuditPending = '';
				let auditPendingCount = 0;
				
				brochureAttachment = {
					...state.brochureAttachment,
					fileAttachments: payload.brochureData.map((cur,index) => {
						const ext = cur.menuUrl.substring(cur.menuUrl.lastIndexOf('.') + 1);
						const showAuditPending = isContractor && ext === 'pdf' && (cur.approved === '9' || cur.approved === 9);
						latestDtTmoFAuditPending = latestDtTmoFAuditPending=='' ? new Date(cur.createDt) : (new Date(cur.createDt) > new Date(latestDtTmoFAuditPending) ? cur.createDt : latestDtTmoFAuditPending);
						auditPendingCount += (cur.approved === '0' || showAuditPending) ? 1 : 0;
						return {
							...cur,
							uploaded: true,
							ext,
							fileId: cur?.id || cur.productId,
							status: (cur.approved === '0' || showAuditPending) ? 'Audit Pending' : null,
							url: ext === 'pdf' ? `/vendor/manage-products/common-wrapper/CORS?url=${cur.menuUrl}` : cur.menuUrl,
							extension: ext,
							download: ext === 'pdf'
						};
					}),
					latestDtTmoFAuditPending: latestDtTmoFAuditPending,
					auditPendingCount: auditPendingCount
				}
			}
			return {
				...state,
				listing,
				brochureAttachment,
				allProducts
			};
		}
		case TOGGLE_PROD_CONFLICT: {
			let newState = {...state};
			newState.showProdConflict = typeof newState.showProdConflict == 'undefined'?true:!newState.showProdConflict;
			if(newState.showProdConflict){
				newState.conflictProdKey = payload.conflictProdKey;
			}else {
				newState.conflictProdKey = '';
			}
			return newState;
		}
		case RESET_LISTING_DATA: {
			return {
				...state,
				listing: initialListingObj,
				brandSelDesel: {
					list: {},
					showActive: false,
					showDeactive: false,
					activateCount: 0,
					deactivateCount: 0,
					changedList: []
				}
			};
		}
		case LISTING_FILTER : {
			return {...state,
			filterProductObj : payload
			}
		}
		case PENDING_TABS : {
			return { ...state, pendingTabs: payload }
		}
		case PAUSE_APPROVAL_REDIRECT : {
			return { ...state, pauseApprovalRedirect: payload }
		}
		
		case RESET_RESULT_DATA: {
			let listing = state.listing;
			listing.results = []
			return {
				...state,
				listing,
			};
		}
		case TOGGLE_ADD_PRODUCT_SLIDER: {
			let newState = {
				...state
			}
			newState.isAddProductSlider = payload.isAddProductSlider
			return newState;
		}
		case TOGGLE_ADD_EDIT_BUTTON_ANIMATION: {
			let newState = {
				...state
			}
			newState.isAddEditButtonAnimation = payload.isAddEditButtonAnimation
			return newState
		}
		case FROM_EDIT_PRODUCT_SLIDER: {
			let newState = {
				...state
			}
			newState.fromEditProductService = payload.fromEditProductService;
			return newState;
		}	
		case TOGGLE_SEARCH_SLIDER: {
			let newState = {
				...state
			};
			newState.isSearchSliderOpen = payload.isSearchSliderOpen;
			return newState;
		}
		case TOGGLE_ACTION_CARD_SLIDER: {
			let newState = {
				...state
			};
			newState.isActionCardSliderOpen = payload.isActionCardSliderOpen;
			return newState;
		}
		case TOGGLE_SUPPORT_SLIDER: {
			let newState = {
				...state
			}
			newState.showSupportSlider = payload.show;
			return newState;
		}
		case ACTION_CARD_FILTER: {
			let newState = {
				...state
			}
			newState.actionCardFilter.cardName = payload.cardName;
			newState.actionCardFilter.filterQuery = payload.filterQuery;
			newState.actionCardFilter.type = payload.type;
			return newState;
		}
		case RELOAD_ACTION_CARD_SLIDER: {
			let newState = {
				...state
			};
			newState.isReloadCardSlider = payload.isReloadCardSlider;
			return newState;
		} 
		case SET_PRODUCT_SLIDER_DATA: {
			const oldResults =
				payload.isReset || payload.currentPage === 1
					? []
					: state.productList.results;

			let allProducts = state.allProducts;
			payload.productData.map((product, index) => {
				const curLocalPRoduct = allProducts[product.productId];
				allProducts[product.productId] = getCurrentLocalProduct(
					curLocalPRoduct,
					product,
					payload.videos
				);
				payload.productData[index] = {
					productId: product.productId,
					attachmentPresent: product.attachmentPresent,
					// associatedSuppliers: product?.associatedSuppliers || [],
					// associatedSuppliersDetails: product?.associatedSuppliersDetails || [],
					// isAutoReorderLevel: product?.isAutoReorderLevel || true,
					// reorderLevel: product?.reorderLevel || 0,
					// isAutoReorderQuantity: product?.isAutoReorderQuantity || true,
					// reorderQuantity: product?.reorderQuantity || 0,
					// isPrescriptionRequired: product?.isPrescriptionRequired ? true : false,
					// selectedProductGroupIds: product?.selectedProductGroupIds || 0,
					// productGroupBreadCrumbList: product?.productGroupBreadCrumbList || [],
					// productGroup: product?.productGroup || 0,
					// enquiryFormId: product?.enquiryFormId,
					// outletWiseDeliveryList: product?.outletWiseDeliveryList || [],
					// accountMongoId: product?.accountMongoId || ''
					completeProductObj: product					
				};
				// payload.completeProductObj[index] = product;
			});
			const productList = {
				currentPage: payload.currentPage,
				results: oldResults.concat(payload.productData),
				allResultsFetched: payload.productData.length < 25,
			}
			return {
				...state,
				productList,
				allProducts
			}
		}
		case SET_SEARCH_DATA: {
			console.log('state.allProducts',state.allProducts);
			let allProducts = state.allProducts;
			const search = {
				results: payload.productData,
				searchQuery: payload.searchQuery,
				searchTab: state?.tabKey || state?.search?.searchTab
			};
			search.results.map((product, index) => {
				const curLocalPRoduct = allProducts[product.productId];
				allProducts[product.productId] = getCurrentLocalProduct(
					curLocalPRoduct,
					product,
					payload.videos
				);
				search.results[index] = {
					productId: product.productId
				};
			});
			console.log(';b4 return',state,'search',search);
			return {
				...state,
				search
			};
		}
		case SET_ACTION_CARD_DATA: {
			console.log('state.allProducts',state.allProducts);
			console.log('payload',payload);
			let allProducts = state.allProducts;
			const actionCardData = {
				results: payload.productData,
				filterQuery: payload.filterQuery,
				cardName: payload.cardName
			};
			actionCardData.results.map((product, index) => {
				const curLocalPRoduct = allProducts[product.productId];
				allProducts[product.productId] = getCurrentLocalProduct(
					curLocalPRoduct,
					product,
					payload.videos
				);
				actionCardData.results[index] = {
					productId: product.productId
				};
			});
			return {
				...state,
				actionCardData
			};
		}
		case EMPTY_SEARCH_DATA: {
			const search = {
				results: [],
				searchQuery: '',
				searchTab:''
			};
			return {
				...state,
				search
			};
		}
		case UPDATE_PRODUCT_PRICE: {
			let newState = {
				...state
			};
			var product = { ...newState.allProducts[payload.productId] };
			product.priceObj = { ...product.priceObj };
			product.priceObj = payload.priceObj;
			// product.sellingPrice =
			// 	payload.sellingPrice;
			newState.allProducts[payload.productId] = product;
			newState.productUnderEdit = newState.allProducts[payload.productId];
			return {
				...newState
			};
		}
		case UPDATE_PRODUCT_SELLING_PRICE: {
			let newState = {
				...state
			};
			var product = { ...newState.allProducts[payload.productId] };
			// product.priceObj = { ...product.priceObj };
			// product.priceObj = payload.priceObj;
			product.sellingPrice = payload.price;
			// 	payload.sellingPrice;
			newState.allProducts[payload.productId] = product;
			newState.productUnderEdit = newState.allProducts[payload.productId];
			return {
				...newState
			};
		}
		case SET_APPROVAL_PENDING: {
			let tempState = { ...state };
			tempState.approvalPendingList = payload.approvalPendingList;
			return tempState;
		}
		case SET_PRODUCT_CONFLICT: {
			let tempState = { ...state };
			tempState.productConflictList = payload.productConflictList;
			return tempState;
		}
		case SET_AUDIT_PENDING: {
			let tempState = { ...state };
			tempState.auditPendingList = payload?.auditPendingList || [];
			tempState.objectionalAuditPendingList = payload?.objectionalAuditPendingList || [];
			return tempState;
		}
		case SET_REJECTED_PRODUCTS: {
			let tempState = { ...state };
			tempState.rejectedList = payload.rejectedList;
			return tempState;
		}
		case SET_DELETION_PENDING: {
			let tempState = { ...state };
			tempState.deletionPendingList = payload.deletionPendingList;
			return tempState;
		}
		case SET_BRAND_PROD_SELECTION: {
			let tempState = { ...state };
			tempState.brandSelDesel = payload.brandList || {
				list: {},
				showActive: false,
				showDeactive: false,
				activateCount: 0,
				deactivateCount: 0,
			};
			const allProducts = tempState.allProducts;
			const list = tempState.brandSelDesel.list || [];
			tempState.brandSelDesel.showActive = false;
			tempState.brandSelDesel.showDeactive = false;
			tempState.brandSelDesel.activateCount = 0;
			tempState.brandSelDesel.deactivateCount = 0;
			tempState.brandSelDesel.changedList = [];
			let activateCount = 0, deactivateCount = 0;
			for (const [key, value] of Object.entries(list)) {
				const product = allProducts[key];
				if (product.active) {
					tempState.brandSelDesel.showDeactive = true;
					deactivateCount++;
				} else {
					tempState.brandSelDesel.showActive = true;
					activateCount++;
				}
			}
			tempState.brandSelDesel.activateCount = activateCount;
			tempState.brandSelDesel.deactivateCount = deactivateCount;
			return tempState;
		}
		case SET_OBJECTIONAL_PENDING: {
			let tempState = { ...state };
			tempState.objectionableList = payload.objectionableList;
			return tempState;
		}
		case SET_BRAND_PENDING: {
			let tempState = { ...state };
			tempState.brandList = payload.brandList;
			return tempState;
		}
		case SET_GENERIC_DELETION_PENDING: {
			let tempState = { ...state };
			tempState.genericDeletionList = payload.genericDeletionList;
			return tempState;
		}
		case SET_TAB_STATUS: {
			let tempState = { ...state };
			tempState.tabKey = payload.tabKey;
			if(payload.tabKey !== 'brochure'){
				tempState.isActiveBrochure = false;
			}
			return tempState;
		}
		case DELETE_PRODUCT: {
			let newState = {
				...state
			};
			let listing = {
				...newState[newState.currentEditPage]
			};
			let index = getIndexOf(listing.results, payload.productId);
			listing.results.splice(index, 1);
			if(!listing.results.length) {
				listing.showNoProdPage = false;
			}
			newState[newState.currentEditPage] = listing;
			// delete newState.allProducts[payload.productId];
			return {
				...newState
			};
		}
		case SET_ATTACHMENT_DATA_VENDOR: {
			const { productId, fileAttachmentDataVendor } = payload;
			let newState = {
				...state
			};
			const fileAttachmentArr = fileAttachmentDataVendor.map((cur, index) => {
				return {
					id: cur.fileId,
					fileName: cur.fileName,
					originalFileName: cur.originalFileName,
					ext: cur.fileExt,
					uploaded: true,
					isOldFile: true,
					fileKey: +new Date() + index
				}
			})
			newState.allProducts[productId] = {
				...newState.allProducts[productId],
				fileAttachmentArr
			}
			return newState;
		}
		case HIDE_PRODUCT_EDIT_SLIDER: {
			return {
				...state,
				showAddEditProduct: false,
				showAddEditProductOmni:false,
			}
		}
		case SHOW_HIDE_EDIT_OPTION: {
			return {
				...state,
				showEditOptions: payload.show,
				cropperData: payload.cropperData
			}
		}
		case SHOW_PRODUCT_EDIT_SLIDER:{
			return {
				...state,
				showAddEditProduct: !payload.viaOmni,
				viaSuggested: payload.viaSuggested,
				showAddEditProductOmni:payload.viaOmni,
			}
		}
		case HIDE_ITEM_SEARCH_SLIDER:{
			return {
				...state,
				showItemSearch: false,
			}
		}
		case SHOW_ITEM_SEARCH_SLIDER:{
			return {
				...state,
				showItemSearch: true,
				showItemSearchProdSer : payload
			}
		}
		case SHOW_NOT_FOUND_MODAL: {
			return {
				...state,
				showNotFoundModal: true,
				barcode: payload.barcode,
				closeCB: payload.closeCB
			}
		}
		case HIDE_NOT_FOUND_MODAL: {
			return {
				...state,
				showNotFoundModal: false
			}
		}
		case EDIT_PRODUCT: {
			let newState = {
				...state,
				auditData: {
					textAreaValue: '',
					checkedValue: ''
				},
				uomType: '',
				showAddEditProduct: !payload.viaOmni,
				showEnrichEditProduct: false,
				showAddEditProductOmni:payload.viaOmni,
			};
			newState.isEnrich = false;
			const product = payload.productData;
			if (product.error) {
				newState.editProduct = {
					error: true
				};
				return newState;
			}
			if(payload.viaSuggested){
				newState.viaSuggested = payload.viaSuggested;
			}
			if (product.isObjectionable) {
				if (product.productId) {
					product.productId = objectionalKeyHandling({
						key: 'ADD',
						value: product.productId,
						id: product.id
					});
				} else {
					product.productId = objectionalKeyHandling({
						key: 'ADD',
						value: '',
						id: product.id
					});
				}
			}
			const productId = product.productId;
			const isDuplicate = payload.isDuplicate;
			if (isDuplicate || !newState.allProducts[productId]) {
				newState.allProducts[productId] = {
					imageUrlArr: product.imageUrlArr,
					videoUrlIds: product.videoUrlIds
				};
			}
			if (!(newState.allProducts[productId].videoUrlIds && newState.allProducts[productId].videoUrlIds?.length) && product.videoUrlIds?.length) {
				newState.allProducts[productId].videoUrlIds = product.videoUrlIds;
			}
			const fileAttachmentArr = payload.attachmentData.map((cur, index) => {
				return {
					id: cur.fileId,
					fileName: cur.fileName,
					ext: cur.fileExt,
					uploaded: true,
					isOldFile: true,
					fileKey: +new Date() + index
				}
			})
			newState.allProducts[productId] = {
				...newState.allProducts[productId],
				fileAttachmentArr
			}
			const curLocalPRoduct = newState.allProducts[productId];
			newState.editProduct = getCurrentLocalProduct(
				curLocalPRoduct,
				product,
				payload.videos
			);
			newState.editProduct.imageUrlArr = JSON.parse(
				JSON.stringify(newState.editProduct.imageUrlArr)
			);
			payload.bizSuggestion = payload.bizSuggestion || {};
			if (!payload.bizSuggestion.data) {
				payload.bizSuggestion.data = [{ bizType: 'Retailer', natCatId: 'Retailer' }, { bizType: 'Wholesaler', natCatId: 'Wholesaler' }, { bizType: 'Exporter', natCatId: 'Exporter' }, { bizType: 'Manufacturer', natCatId: 'Manufacturer' }];
			}
			formatAttributes(payload.bizSuggestion.attributes);
			newState.editProduct.attributes = payload.bizSuggestion.attributes
			delete payload.bizSuggestion.attributes;
			newState.editProduct.bizSuggestion = payload.bizSuggestion;
			newState.editProduct.toggleBiz = payload.bizSuggestion.status && !payload.bizSuggestion.selected;
			newState.editProduct.customAttrs = product.custAttributes && product.custAttributes.length ? product.custAttributes : [{
				name: '',
				value: '',
				key: Date.now()
			}];
			if (newState.editProduct.bizSuggestion.data && newState.editProduct.bizSuggestion.data.length && newState.editProduct.bizSuggestion.data[0]) {
				newState.editProduct.bizSuggestion.bizType = newState.editProduct.bizSuggestion.data[0].bizType;
			}
			newState.editProduct.oldData = payload.oldProductData || {};
			const oldBizSuggestion = payload.oldBizSuggestion;
			if (oldBizSuggestion && oldBizSuggestion.oldAttributes) {
				newState.editProduct.oldData.attributes = oldBizSuggestion.oldAttributes;
			}
			if(product.salesTaxJson){
				newState.editProduct.salesTax = JSON.parse(product.salesTaxJson);
			}
			if(product.purchaseTaxJson){
				newState.editProduct.purchaseTax = JSON.parse(product.purchaseTaxJson);
			}
			if(product?.productSynonym){
				newState.editProduct.productSynonym = product.productSynonym;
			}
			if(product.hsnsacNo){
				newState.editProduct.hsnSacNo = product.hsnsacNo;
			}
			if(product.mrp_status === 'REJECTED' || product.mrp_status === 'IMAGES REQUIRED'){
				newState.editProduct.isUnknownMrpValue = true
			}
			if(isDuplicate) {
				newState.editProduct.sku = '';
				newState.editProduct.consignment_no = '';
			}
			return newState;
		}
		case EDIT_ENRICH_PRODUCT: {
			let newState = {
				...state,
				uomType: '',
				showAddEditProduct: false,
				showAddEditProductOmni:false,
				showEnrichEditProduct: true
			};
			newState.isEnrich = true;
			const product = payload.productData;
			if (product.error) {
				newState.editProduct = {
					error: true
				};
				return newState;
			}
			const productId = product.productId;
			const isDuplicate = payload.isDuplicate;
			if (isDuplicate || !newState.allProducts[productId]) {
				newState.allProducts[productId] = {
					imageUrlArr: product.imageUrlArr,
					videoUrlIds: product.videoUrlIds
				};
			}
			if (!(newState.allProducts[productId].videoUrlIds && newState.allProducts[productId].videoUrlIds?.length) && product.videoUrlIds?.length) {
				newState.allProducts[productId].videoUrlIds = product.videoUrlIds;
			}
			const fileAttachmentArr = payload.attachmentData.map((cur, index) => {
				return {
					id: cur.fileId,
					fileName: cur.fileName,
					ext: cur.fileExt,
					uploaded: true,
					isOldFile: true,
					fileKey: +new Date() + index
				}
			})
			newState.allProducts[productId] = {
				...newState.allProducts[productId],
				fileAttachmentArr
			}
			const curLocalPRoduct = newState.allProducts[productId];
			newState.editProduct = getCurrentLocalProduct(
				curLocalPRoduct,
				product,
				payload.videos
			);
			newState.editProduct.imageUrlArr = JSON.parse(
				JSON.stringify(newState.editProduct.imageUrlArr)
			);
			return newState;
		}
		case INIT_ADD_PRODUCT: {
			let newState = {
				...state,
				uomType: '',
				auditData: {
					textAreaValue: '',
					checkedValue: ''
				},
				showAddEditProduct: !payload.viaOmni,
				showAddEditProductOmni:payload.viaOmni,
				showEnrichEditProduct:false,
				viaSuggested: payload.viaSuggested
			}
			const productId = 'ADD_PRODUCT';
			if (state.editProduct && state.editProduct.dontResetEditProduct) {
				newState.editProduct = { ...state.editProduct };
				delete newState.editProduct.dontResetEditProduct;
				return newState;
			}
			let data = {};
			if (payload && payload.data) {
				newState.auditData.checkBoxData = payload.data
				data = { checkBoxOptions: payload.data }
			}
			if (payload && payload.headerData) {
				data = { ...data };
				data.jdWebsiteUrl = payload.headerData.companyWebsiteLink;
				data.jdBestPracticeWebsiteUrl = payload.headerData.bestPracticeWebsiteLink;
				data.jdCatList = payload.headerData.keywordList;
				data.jdLink = payload.headerData.jdLink;
				data.source = payload.headerData.source;
			}

			newState.editProduct = {
				productId,
				productName: '',
				customAttrs: [{
					name: '',
					value: '',
					key: Date.now()
				}],
				...data,
				bestBeforeUnit: "months",
				expiryBy: "manufacturing_date",
				categoryType: payload.selectedProductType || state.selectedCategoryType,
				specificDurationUnit: state.selectedCategoryType === 'service' ? 'months' : '',
				bizSuggestion: { data: [{ bizType: 'Retailer', natCatId: 'Retailer' }, { bizType: 'Wholesaler', natCatId: 'Wholesaler' }, { bizType: 'Exporter', natCatId: 'Exporter' }, { bizType: 'Manufacturer', natCatId: 'Manufacturer' }] }
			};
			if(payload.selectedProductType) {
				newState.selectedCategoryType = payload.selectedProductType;
			}
			let dontReset = false;
			if (newState.allProducts[productId]) {
				dontReset = newState.allProducts[productId].dontReset
				delete newState.allProducts[productId].dontReset
			}
			//if(!newState.allProducts[variantId]){
			if (!dontReset) {
				newState.allProducts[productId] = {
					imageUrlArr: [],
					videoUrlIds: []
				};
			}
			//}
			return newState;
		}
		case SAVE_ADD_EDIT_PRODUCT: {
			let newState = {
				...state
			};
			let productData = newState.editProduct;
			const productId = productData.productId;
			if (productId == 'ADD_PRODUCT') {
				newState.allProducts = {
					...newState.allProducts
				}
				newState.allProducts[payload.productId] = newState.allProducts.ADD_PRODUCT;
				let imagesBeingUploaded = [...newState.imagesBeingUploaded];
				if (imagesBeingUploaded.length) {
					imagesBeingUploaded = imagesBeingUploaded.map((cur) => {
						if (cur.productId === 'ADD_PRODUCT') {
							cur.productId = payload.productId;
						}
						return cur;
					})
					newState.imagesBeingUploaded = imagesBeingUploaded;
				}
				//delete newState.allProducts.ADD_PRODUCT;
			}
			//newState.editProduct = {};
			return newState;
		}
		case SAVE_REJECTED_VIA_AUDIT : {
			let newState = {...state}
			newState.initialRespRejectAudit = action.payload
			return newState;
		}
		case DISCARD_ADD_PRODUCT_MEDIA: {
			let newState = {
				...state
			};
			let productData = newState.editProduct;
			const productId = productData.productId;
			if (productId == 'ADD_PRODUCT') {
				let imagesBeingUploaded = [...newState.imagesBeingUploaded];
				if (imagesBeingUploaded.length) {
					imagesBeingUploaded = imagesBeingUploaded.filter((cur) => cur.productId !== 'ADD_PRODUCT')
					newState.imagesBeingUploaded = imagesBeingUploaded;
				}
			}
			newState.showAddEditProduct = false;
			newState.showEnrichEditProduct = false;
			newState.showAddEditProductOmni=false;
			return newState;
		}
		case RESET_PRODUCT_DATA: {
			let newState = {
				...state
			};
			const product = newState.editProduct;
			const productId = product?.productId || 'ADD_PRODUCT';
			if (productId == 'ADD_PRODUCT' && !(payload && payload.dontResetEditProduct)) {
				newState.allProducts.ADD_PRODUCT = {
					imageUrlArr: [],
					videoUrlIds: []
				}
			} else {
				if(newState.allProducts[productId] && payload && payload.AddImagestoListing){
					newState.allProducts[productId].imageUrlArr = product.imageUrlArr || [];
				}
			}
			if (payload && payload.dontResetEditProduct) {
				newState.editProduct = {
					...newState.editProduct,
					dontResetEditProduct: true
				}
			}else {
				newState.editProduct = {
					...newState.allProducts.ADD_PRODUCT,
					bizSuggestion: { data: [{ bizType: 'Retailer', natCatId: 'Retailer' }, { bizType: 'Wholesaler', natCatId: 'Wholesaler' }, { bizType: 'Exporter', natCatId: 'Exporter' }, { bizType: 'Manufacturer', natCatId: 'Manufacturer' }] }
				};
			}
			return newState;
		}
		case PRODUCTSCORE: {
			let editProductScore = state.allProducts[payload.id]
			editProductScore.productScore = payload.score
			editProductScore.finalWeight = payload.score
			let newState = {
				...state
			}
			return newState;
		}
		case PRODUCT_UNDER_EDIT: {
			let newState = {
				...state
			};
			newState.productUnderEdit = payload.productUnderEdit;
			return newState;
		}
		case UPDATE_EDIT_PRODUCT_DETAIL: {


			let editProduct = {
				...state.editProduct
			};
			let uomT = '';
			if (payload.key) {
				const { key, value } = payload;
				uomT = payload.uomType;
				editProduct = {
					...editProduct,
					[key]: value
				};
			} else {
				if(payload.salesTax || payload.hsnSacNo || payload.productSynonym){
					editProduct = {...editProduct , ...payload};
				}else{
					Array.isArray(payload) && payload.length > 0 && payload.forEach(({ key, value, uomType }) => {
						if (uomType) {
							uomT = uomType;
						}
						let val = value;
						if(['mrp','sellingPrice','sellingOnlinePrice'].includes(key) && Number(val) < 1){
							val = '';
						}
						editProduct = {
							...editProduct,
							[key]: val
						};
					});
				}

			}
			let uomType = uomT || editProduct.uomType;
			if (uomType === 'PACKED' || !uomType) {
				editProduct.minOrderQuantity = Math.floor(editProduct.minOrderQuantity);
			}

			return {
				...state,
				editProduct,
				uomType: uomT
			};
		}
		case UPDATE_PRODUCT_IMAGE: {
			const newState = {
				...state
			};

			/*const productList = {
				...newState[newState.currentEditPage].results
			};
			var index;
			for (var key in productList) {
				if (productList[key].variantId === payload.editProductId) {
					index = key;
				}
			}*/
			let productData = { ...newState.allProducts[payload.editProductId] }; //productList[index];

			const newImageUrlArr = productData.imageUrlArr || [];
			const imageIndex = payload.updateDefaultIndex
				? payload.updateDefaultIndex
				: getUploadKeyIndex(newImageUrlArr, payload.imgIndex);
			if (imageIndex != -1) {
				newImageUrlArr[imageIndex] =
					payload.initialReq && payload.updateDefaultIndex
						? {
							...payload.imageUrl
						}
						: {
							...newImageUrlArr[imageIndex],
							...payload.imageUrl
						};
			} else {
				newImageUrlArr.push(payload.imageUrl);
			}
			productData.imageUrlArr = newImageUrlArr;
			if (newImageUrlArr.length >= payload.noOfFilesToUpload) {
				let allFilesUploaded = true;
				let finalImageUrl = [];
				let finalVideoUrl = {};
				newImageUrlArr.forEach((imgObj, index) => {
					if (typeof imgObj.uploaded === 'undefined') {
						allFilesUploaded = false;
					} else if (!imgObj.uploaded) {
						newImageUrlArr.splice(index, 1);
					} else {
						if (imgObj.isVideo) {
							finalVideoUrl[index] = {
								imgURL: imgObj.imgURL,
								thumbnailURL: imgObj.thumbnailURL
							};
						} else {
							finalImageUrl.push(imgObj.imgURL);
						}
					}
				});
				if ((finalImageUrl.length + Object.keys(finalVideoUrl).length) === newImageUrlArr.length) {
					allFilesUploaded = true;
				}
				if (allFilesUploaded) {
					let updateProductReq = true;
					if (payload.ignoreSave || payload.editProductId === 'ADD_PRODUCT') {
						updateProductReq = false;
					}
					if (payload.editProductId === 'ADD_PRODUCT' && newState.allProducts[payload.editProductId] && payload.dontReset) {
						productData.dontReset = true;
					}
					updateProductReq && updateProductMediaService({
						productId: payload.editProductId,
						imageUrl: finalImageUrl.join(','),
						videoUrl: JSON.stringify(finalVideoUrl),
						token: payload.token,
						source: payload.source
					});
				}
			}
			newState.allProducts[payload.editProductId] = productData;
			// newState.editProduct.showMax = payload.showMaxImagesToast;
			newState.productUnderEdit = productData;
			return newState;
		}
		case UPLOAD_IMAGE_FROM_LINK: {
			let newState = {
				...state
			};
			let productData = { ...newState.allProducts[payload.productId] };
			const newImageUrlArr = [...productData.imageUrlArr] || [];
			newImageUrlArr.push(payload.imageUrlObj);
			productData.imageUrlArr = newImageUrlArr;
			productData.dontReset = payload.productId === 'ADD_PRODUCT';
			newState.productUnderEdit = productData;
			newState.allProducts[payload.productId] = productData;
			if(newState.showAddEditProduct || newState.showEnrichEditProduct || (payload.viaOmni && newState.showAddEditProductOmni)){
				newState.editProduct.imageUrlArr = newImageUrlArr;
			}
			return newState;
		}
		case UPLOAD_MULTIPLE_IMAGES: {
			let newState = {
				...state
			};
			let productData = { ...newState.allProducts[payload.productId] };
			const newImageUrlArr = [...payload.imageUrlArr] || [];
			productData.imageUrlArr = newImageUrlArr;
			productData.dontReset = payload.productId === 'ADD_PRODUCT';
			newState.productUnderEdit = productData;
			newState.allProducts[payload.productId] = productData;
			if(newState.showAddEditProduct || newState.showEnrichEditProduct || newState.showAddEditProductOmni){
				newState.editProduct.imageUrlArr = newImageUrlArr;
			}
			return newState;
		}
		case DELETE_VIDEO_URL_ID_ALL_PRODUCTS: {
			let newState = {
				...state
			};
			let productData = { ...newState.allProducts[payload.productId] };
			newState.allProducts[payload.productId] = {...productData, videoUrlIds: []};
			return newState;
		}
		case LINK_VIDEO_TO_PRODUCT:
		case UPDATE_VIDEO_ID_PRODUCT:
		case UPDATE_PRODUCT_VIDEO: {
			const newState = {
				...state
			};
			if(payload.editProductId) {
				let productData = { ...newState.allProducts[payload.editProductId] };
				let newVideoUrlIds = [...productData.videoUrlIds];
				const tempVideoId = payload.imgIndex || payload.videoId;
				if (payload.updateVideoId) {
					newVideoUrlIds = newVideoUrlIds.map((curId, index) => {
						if (curId === payload.videoId) {
							curId = payload.newVideoId
						}
						return curId
					})
					if (!newVideoUrlIds.length) {
						newVideoUrlIds = [payload.newVideoId]
					}
				} else if (newVideoUrlIds.indexOf(tempVideoId) === -1) {//adding length check as of now only one video is allowed
					newVideoUrlIds = [tempVideoId];
					// newVideoUrlIds.push(tempVideoId);
				}
				productData.videoUrlIds = newVideoUrlIds;
				newState.allProducts[payload.editProductId] = productData;
				newState.productUnderEdit = productData;
			}
			return newState;
		}
		case UNLINK_VIDEO: {
			const newState = {
				...state
			}
			let productData = { ...newState.allProducts[payload.productId] };
			productData.videoUrlIds = [];
			if (payload.reviewStatus) {
				productData.reviewStatus = payload.reviewStatus;
			}
			newState.allProducts[payload.productId] = productData;
			newState.productUnderEdit = productData;
			newState.undoInfo = payload.undoInfo;
			return newState;
		};
		case UPLOAD_YOUTUBE_VIDEO: {
			const newState = { ...state };
			let productData = { ...newState.allProducts[payload.productId] };
			productData.videoUrlIds = [payload.videoId];
			productData.dontReset = payload.productId === 'ADD_PRODUCT';
			productData.linkModified = true;
			newState.allProducts[payload.productId] = productData;

			newState.productUnderEdit = productData;
			return newState;
		}
		case TOGGLE_EDIT_IMAGE_OPTIONS: {
			return {
				...state,
				editImageOptions: payload
			};
		}
		case DELETE_PRODUCT_IMAGE: {
			const newState = {
				...state
			};
			let productData = { ...newState.allProducts[payload.productId] };
			if (payload.reviewStatus) {
				productData.reviewStatus = payload.reviewStatus;
			}
			productData.imageUrlArr = [...payload.imageUrlArr];
			newState.allProducts[payload.productId] = productData;
			newState.productUnderEdit = productData;
			newState.undoInfo = payload.undoInfo;
			let prodData = {...newState.editProduct};
			prodData.imageUrlArr = [...payload.imageUrlArr];
			newState.editProduct = prodData;
			newState.editProduct.showMax = false;
			return newState;
		}
		case RESTORE_PRODUCT_DATA: {
			const newState = {
				...state,
			};
			const undoInfo = newState.undoInfo;
			if (undoInfo) {
				if(undoInfo.isAddEditPage){
					const editProduct = {...newState.editProduct};
					let newImageUrlArr = [...editProduct.imageUrlArr];
					newImageUrlArr.splice(undoInfo.index, 0, undoInfo.data);
					editProduct.imageUrlArr = newImageUrlArr;
					newState.editProduct = editProduct;
					return newState;
				}
				let productData = { ...newState.allProducts[undoInfo.productId] };
				const ignoreSave = undoInfo.productId === 'ADD_PRODUCT';
				switch (undoInfo.type) {
					case 'image':
						let newImageUrlArr = [...productData.imageUrlArr];
						newImageUrlArr.splice(undoInfo.index, 0, undoInfo.data);
						productData.imageUrlArr = newImageUrlArr;
						newState.allProducts[undoInfo.productId] = productData;
						newState.productUnderEdit = productData;
						//due to changes in Structure
						productData = {...newState.editProduct};
						newImageUrlArr = [...productData.imageUrlArr];
						newImageUrlArr.splice(undoInfo.index, 0, undoInfo.data);
						productData.imageUrlArr = newImageUrlArr;
						newState.editProduct = productData;
						!ignoreSave &&
							restoreProductDataReq({
								imageUrlArr: newImageUrlArr,
								productId: undoInfo.productId,
								type: 'image',
								token: payload.token,
								source: payload.source
							});
						newState.undoInfo = null;
						break;
					case 'video':
						break;
				}
			}
			return newState;
		}
		case SHOW_TOAST_MESSAGE_LOCAL:
		case HIDE_TOAST_MESSAGE_LOCAL: {
			return {
				...state,
				undoInfo: null
			}
		}
		case SET_CURRENT_EDIT_PAGE: {
			return {
				...state,
				currentEditPage: payload
			};
		}
		case UPDATE_IMAGES_BEING_UPLOADED: {
			const newState = {
				...state,
				imagesBeingUploaded: payload
			};
			return newState;
		}
		case SET_APP_CAT_COV_USER: {
			let newState = {...state};
			newState.isUserApprovedForCatCoverage = action.payload;
			return newState;
		}
		case GET_BIZ: {
			const newState = { ...state };
			newState.editProduct = { ...newState.editProduct };
			newState.editProduct.bizSuggestion = payload || {};
			if (!newState.editProduct.bizSuggestion.data) {
				newState.editProduct.bizSuggestion.data = [{ bizType: 'Retailer', natCatId: 'Retailer' }, { bizType: 'Wholesaler', natCatId: 'Wholesaler' }, { bizType: 'Exporter', natCatId: 'Exporter' }, { bizType: 'Manufacturer', natCatId: 'Manufacturer' }];
			}
			if (payload.status) {
				newState.editProduct.toggleBiz = !payload.selected;
			} else {
				newState.editProduct.toggleBiz = false;
			}
			if (payload.attributes) {
				formatAttributes(payload.attributes);
			}
			if (payload.data) {
				payload.data = payload.data.map((cur) => {
					if (cur && cur.bizType && !cur.natCatId) {
						cur.natCatId = cur.bizType
					}
					return cur
				})
			}
			// newState.editProduct.attributes = payload.attributes
			return newState;
		}
		case SET_PRODUCT_SPECIFICATION: {
			const newState = { ...state };
			newState.editProduct = { ...newState.editProduct };
			const attributes = [...newState.editProduct.attributes];
			const index = payload.index;
			const values = payload.values;
			attributes[index].values = values;
			if (["FREETEXT"].indexOf(attributes[index].type) == -1 && values.indexOf("other") != -1) {
				if (!attributes[index + 1] || !attributes[index + 1].otherFlag) {
					attributes.splice(index + 1, 0, {
						"name": "other " + attributes[index].name,
						"options": [""],
						"type": "FREETEXT",
						otherFlag: true
					});
				}
			} else {
				if (attributes[index + 1] && attributes[index + 1].otherFlag) {
					attributes.splice(index + 1, 1);
				}
			}
			newState.editProduct.attributes = attributes;
			return newState;
		}
		case SETPSVINFODATA : {
			const newState = { ...state };
			let prodUOM = action.data.data['productUom'];
			prodUOM = prodUOM ?  prodUOM.map(cur => {
				let unique = [];
				if(cur.UNIT && cur.UNIT.length) {
					const unitList = cur.UNIT.map(item => ({
						...item,
						isPopular: 1
					}));
					const mainUomList = action.mainUOM['productUOM'].map(item => ({
						...item,
						isPopular: 0
					}));
					const combined = [...unitList, ...mainUomList];
					const seen = new Set();
					for (const item of combined) {
						if (!seen.has(item.val.toLowerCase())) {
							seen.add(item.val.toLowerCase());
							unique.push(item);
						}
					}
					return {...cur,UNIT: unique};
				}
				return cur;
			}) : [];
			let serUOM = action.data.data['serviceUom'];
			serUOM = serUOM ? serUOM.map(cur => {
				let unique = [];
				if(cur.UNIT && cur.UNIT.length) {
					const unitList = cur.UNIT.map(item => ({
						...item,
						isPopular: 1
					}));
					const mainUomList = action.mainUOM['serviceUOM'].map(item => ({
						...item,
						isPopular: 0
					}));
					const combined = [...unitList, ...mainUomList];
					const seen = new Set();
					for (const item of combined) {
						if (!seen.has(item.val.toLowerCase())) {
							seen.add(item.val.toLowerCase());
							unique.push(item);
						}
					}
					return {...cur,UNIT: unique};
				}
				return cur;
			}) : [];
			newState.psvInfoData = {productUom: prodUOM,serviceUom: serUOM};
			return newState;
		}
		case UPDATE_BIZ: {
			const newState = { ...state };
			if (newState.editProduct && newState.editProduct.bizSuggestion) {
				newState.editProduct.bizSuggestion.bizType = payload.natCatId;
			}
			return newState;
		}
		case TOGGLE_BIZ: {
			const newState = { ...state };
			newState.editProduct.toggleBiz = payload;
			return newState;
		}
		case TOGGLE_PRODUCT_VISIBILITY: {
			const newState = { ...state };
			newState.allProducts[payload.productId].visibility = payload.visibility;
			return newState;
		}
		case SET_ATTACHMENT_DATA: {
			const {
				productId,
				data
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] }
			if (!allProducts[productId].fileAttachmentArr) {
				allProducts[productId].fileAttachmentArr = [];
			} else {
				allProducts[productId].fileAttachmentArr = [
					...allProducts[productId].fileAttachmentArr
				]
			}
			const fileAttachmentArr = allProducts[productId].fileAttachmentArr;
			let i = 0;
			for (; i < fileAttachmentArr.length; i++) {
				if (fileAttachmentArr[i].fileKey == data.fileKey) {
					break;
				}
			}
			if(Array.isArray(data)) {
				allProducts[productId].fileAttachmentArr = data;
			}else {
				allProducts[productId].fileAttachmentArr[i] = data;
			}
			return {
				...state,
				allProducts
			}
		}
		case RESET_FILE_ATTACHMENT_DATA: {
			const {
				productId,
				fileAttachmentArr
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] }
			allProducts[productId].fileAttachmentArr = [
				...allProducts[productId].fileAttachmentArr
			];
			allProducts[productId].fileAttachmentArr = fileAttachmentArr;
			return {
				...state,
				allProducts
			}
		}
		case DELETE_ATTACHMENT_FILE: {
			const {
				productId,
				fileKey
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] }
			allProducts[productId].fileAttachmentArr = [
				...allProducts[productId].fileAttachmentArr
			];
			const fileAttachmentArr = allProducts[productId].fileAttachmentArr;
			fileAttachmentArr.forEach((cur) => {
				if (cur.fileKey == fileKey) {
					cur.isDeleted = true;
				}
			});
			return {
				...state,
				allProducts
			}
		}
		case TOGGLE_EDIT_DISPLAYNAME_MODAL: {
			const {
				modalData,
				show,
				currentFile,
				fromAttachment
			} = action.payload;
			const newState = { ...state };
			newState.uploadedFileModalData = { ...state.uploadedFileModalData };
			newState.uploadedFileModalData.show = show;
			let inputObj = null;
			if (show) {
				newState.fileAttachmentData = { ...state.fileAttachmentData };
				newState.fileAttachmentData.currentFile = { ...state.fileAttachmentData.currentFile };
				newState.fileAttachmentData.currentFile = currentFile;
				const title = 'Edit Display Name';
				const label = 'Display Name';
				inputObj = {
					modalData: {
						title,
						buttonLabel: 'Save',
						type: 'name'
					},
					inputFields: [{
						type: 'text',
						label: label,
						key: 'fileName',
						name: 'filename',
						value: modalData.fileName
					}]
				}
			}
			newState.uploadedFileModalData.inputObj = { ...state.uploadedFileModalData.inputObj };
			newState.uploadedFileModalData.inputObj = inputObj;
			return newState;
		}
		case RENAME_PRODUCT_ATTACHMENT: {
			const {
				productId,
				fileKey,
				fileName
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] };
			allProducts[productId].fileAttachmentArr = [
				...allProducts[productId].fileAttachmentArr
			]
			let i = 0;
			const fileAttachmentArr = allProducts[productId].fileAttachmentArr;
			for (; i < fileAttachmentArr.length; i++) {
				if (fileAttachmentArr[i].fileKey == fileKey) {
					break;
				}
			}
			allProducts[productId].fileAttachmentArr[i].fileName = fileName
			return {
				...state,
				allProducts
			}
		}
		case CANCEL_PENDING_FILES: {
			const {
				productId
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] };
			allProducts[productId].fileAttachmentArr = [
				...allProducts[productId].fileAttachmentArr
			]
			const fileAttachmentArr = allProducts[productId].fileAttachmentArr;
			allProducts[productId].fileAttachmentArr = fileAttachmentArr.filter(cur => cur.uploaded);
			return {
				...state,
				allProducts
			}
		}
		case VIEW_FILE_DETAILS_SLIDER: {
			const {
				show
			} = action.payload;
			const newState = { ...state };
			newState.fileAttachmentData = { ...state.fileAttachmentData };
			newState.fileAttachmentData.showViewDetailsSlider = show;
			return newState;
		}
		case TOGGLE_FILE_PROGRESS_BAR: {
			const {
				show
			} = action.payload;
			const newState = { ...state };
			newState.fileAttachmentData = { ...state.fileAttachmentData };
			newState.fileAttachmentData.showProgressBar = show;
			return newState;
		}
		case MARK_PREVIOUSLY_UPLOADED_FILES: {
			const {
				productId
			} = action.payload;
			const allProducts = state.allProducts;
			allProducts[productId] = { ...allProducts[productId] };
			allProducts[productId].fileAttachmentArr = [
				...allProducts[productId].fileAttachmentArr
			]
			const fileAttachmentArr = allProducts[productId].fileAttachmentArr;
			fileAttachmentArr.forEach((item) => {
				item.isPreviouslyUploaded = true;
			});
			return {
				...state,
				allProducts
			}
		}
		case SET_AUDIT_OBJECT: {
			let newState = { ...state };
			if (!newState.auditData) {
				newState.auditData = {};
			}
			newState.auditData = {
				...newState.auditData,
				...action.payload
			}
			return newState;
		}
		case TOGGLE_CONFIRM_DELETE: {
			let newState = { ...state };
			newState.confirmDeleteModal = payload.confirmDeleteModal;
			return newState;
		}
		case TOGGLE_CONFIRM_APPROVE: {
			let newState = { ...state };
			newState.confirmApproveModal = payload.confirmApproveModal;
			return newState;
		}
		case TOGGLE_TAB: {
			let newState = { ...state };
			newState.isToggleTab = payload.isToggleTab;
			return newState;
		}
		case REDIRECTED_FROM: {
			let newState = { ...state };
			newState.redirectedFrom = payload.redirectedFrom;
			return newState;
		}
		case TOGGLE_INFO_BOX: {
			let newState = { ...state };
			newState.showInfoBox = payload.showInfoBox;
			return newState;
		}
		case FILE_ATTACHMENT_PERMISSION: {
			const {
				permissionData
			} = action.payload;
			const newState = { ...state };
			newState.fileAttachmentData = { ...state.fileAttachmentData };
			newState.fileAttachmentData.permissionData = permissionData;
			return newState;
		}
		case SET_VENDOR_IMAGES: {
			let oldState = state;
			if (payload.isJdPhotoSlider) {
				oldState.jdGalleryImages = payload.imageArr;
			} else {
				oldState.vendorImages = payload.imageArr;
			}
			return oldState
		}
		case SET_VENDOR_OBJECTIONABLE_PRODUCTS: {
			let oldState = state;
			oldState.vendorObjectionableProducts = payload;
			return oldState
		}
		case INITIAL_COUNTRY_CODE: {
			let newState = { ...state };
			newState.countryList = [...payload.data];
			return newState;
		}
		case SET_SELECTED_CATEGORY: {
			let newState = { ...state };
			newState.selectedCategoryType = payload.data;
			return newState;
		}
		case SET_BRAND_SUGGESTION: {
			let newState = {...state};
			newState.brandSuggestion = payload;
			return newState;
		}
		case SET_QUEUE_TYPE: {
			let newState = {...state};
			newState.queueType = payload.queueType;
			return newState;
		}
		case SET_SMART_FILL_DATA: {
			let newState = {...state};
			newState.smartFillData = payload.data;
			return newState;
		}
		case SET_AUDITOR_BRANDED_LOG: {
			let newState = {...state};
			newState.auditorBrandedLog = [...payload.data];
			return newState;
		}
		case SET_SEARCH_BY_DOC_ID: {
			let newState = {...state};
			newState.docIdSearch = payload.docIdSearch;
			return newState;
		}
		case SET_VIA_SUGGESTED: {
			let newState = {...state};
			newState.viaSuggested = payload.viaSuggested;
			return newState;
		}
		case SET_SUGGESTED_VIA_SEARCH: {
			let newState = {...state};
			newState.viaSearch = payload.viaSearch;
			return newState;
		}
		case SET_SHOULD_RETAIN: {
			let newState = {...state};
			newState.shouldRetain = payload;
			return newState;
		}
		case SET_FROM_SELLER: {
			let newState = {...state};
			newState.fromSellerDashboard = payload.fromSellerDashboard;
			return newState;
		}
		case SET_PREVIOUS_TAB_INDEX: {
			let newState = {...state};
			newState.tabIndex = payload.tabIndex;
			return newState;
		}
		case DELETE_IMAGE_FROM_ADD_EDIT:
			return {
				...state,
				undoInfo: payload.undoInfo,
				editProduct: {
					...state.editProduct,
					showMax: false,
					imageUrlArr: [...payload.imageUrlArr]
				}
			}
		case UPLOAD_IMAGE_FROM_ADD_EDIT:{
			if(payload.uploadType === 'MULTIPLE'){
				let imageUrlArr = state?.editProduct?.imageUrlArr || [];
				return {
					...state,
					editProduct:{
						...state.editProduct,
						imageUrlArr: payload.imageUrlObj ? [...imageUrlArr, payload.imageUrlObj] : [...payload.imageUrlArr]
					}
				};
			}else{
				const productData = state.editProduct;
				const newImageUrlArr = productData.imageUrlArr || [];
				const imageIndex = payload.updateDefaultIndex
					? payload.updateDefaultIndex
					: getUploadKeyIndex(newImageUrlArr, payload.imgIndex);
				if (imageIndex != -1) {
					newImageUrlArr[imageIndex] =
						payload.initialReq && payload.updateDefaultIndex
							? {
								...payload.imageUrl
							}
							: {
								...newImageUrlArr[imageIndex],
								...payload.imageUrl
							};
				} else if(payload.isFromPhotoSlider) {
					let imagePath = payload.imageUrl;
					let quickQuotes = imagePath && (imagePath.indexOf('quickquotes') !== -1 || imagePath.indexOf('grocery') !== -1);
					let newImagePath = staticImageDomains[0] + '/product' + imagePath;
					if(quickQuotes) {
						newImagePath = staticImageDomains[3] + '/' + imagePath;
					}
					payload.finalImageSrc = newImagePath;
					if(payload.imageUrl) {
						payload.imgURL = payload.imageUrl;
					}
					newImageUrlArr.push(payload);
				} else {
					newImageUrlArr.push(payload.imageUrl);
				}
				if(payload.editProductId === 'ADD_PRODUCT'){
					productData.productId = 'ADD_PRODUCT'
				}
				productData.imageUrlArr = newImageUrlArr;
				return {
					...state,
					editProduct: productData
				}
			}
		}
		case UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT:{
			const newState = {
				...state
			};
				let productData = { ...newState.editProduct };
				let newVideoUrlIds = productData.videoUrlIds ? [...productData.videoUrlIds]: [];
				const tempVideoId = payload.imgIndex || payload.videoId;
				if (payload.updateVideoId) {
					newVideoUrlIds = newVideoUrlIds.map((curId, index) => {
						if (curId === payload.videoId) {
							curId = payload.newVideoId
						}
						return curId
					})
					if (!newVideoUrlIds.length) {
						newVideoUrlIds = [payload.newVideoId]
					}
				} else if (newVideoUrlIds.indexOf(tempVideoId) === -1) {//adding length check as of now only one video is allowed
					newVideoUrlIds = [tempVideoId];
					// newVideoUrlIds.push(tempVideoId);
				}
				productData.videoUrlIds = newVideoUrlIds;
				newState.editProduct = productData;
			return newState;
		}
		case REMOVE_VIDEO_FROM_ADD_EDIT: {
			const newState = {
				...state,
				editProduct: {
					...state.editProduct,
					videoUrlIds: []
				}
			}
			return newState;
		}
		case UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT:{
			const newState = { ...state };
			let productData = { ...newState.editProduct };
			productData.videoUrlIds = [payload.videoId];
			newState.editProduct = productData;
			return newState;
		}

		case TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER:
			return {
				...state,
				brochureAttachment: {
					...state.brochureAttachment,
					showUploadHistorySlider: payload
				}
			}

			case TOGGLE_BROCHURE_EDITNAME_DIALOG:
				return {
					...state,
				brochureAttachment: {
					...state.brochureAttachment,
					editNameDialog: payload
					}
				}

			case TOGGLE_BROCHURE_FILE_PREVIEW:
				return {
					...state,
					brochureAttachment:{
						...state.brochureAttachment,
						previewFile: {
							...state.brochureAttachment.previewFile,
							fileMimeType: payload.fileType || 'jpg',
							filePreviewToggle: Boolean(payload.show)
						}
					}
				}

			case BROCHURE_TOTAL_FILES_UPLOAD: {
				const progressPercentage = state.brochureAttachment.uploadHistoryFiles.length / (state.brochureAttachment.uploadHistory.totalFiles + payload.length) * 100;
				const preLoadedFiles = Array.from({ length: payload.length }, () => ({ loading: true, id: Date.now().toString(36) + Math.random().toString(36).substr(2) }));
				return {
					...state,
					brochureAttachment: {
						...state.brochureAttachment,
						fileAttachments: [...preLoadedFiles, ...state.brochureAttachment.fileAttachments],
						uploadingFiles: [...state.brochureAttachment.uploadingFiles, ...payload],
						uploadProgress: progressPercentage,
						uploadHistory: {
							...state.brochureAttachment.uploadHistory,
							totalFiles: state.brochureAttachment.uploadHistory.totalFiles + payload.length
						}
					}
				}
			}

			case BROCHURE_TOTAL_FILES_ERROR: {
				const progressPercentage = (state.brochureAttachment.uploadHistoryFiles.length + 1) / state.brochureAttachment.uploadHistory.totalFiles * 100;
				const ind = state.brochureAttachment.fileAttachments.findIndex((l) => l.loading);
				return {
						...state,
						brochureAttachment: {
							...state.brochureAttachment,
						fileAttachments: [...state.brochureAttachment.fileAttachments.slice(0, ind), ...state.brochureAttachment.fileAttachments.slice(ind + 1)],
						uploadHistoryFiles: [...state.brochureAttachment.uploadHistoryFiles, payload],
						uploadProgress: progressPercentage,
							uploadHistory: {
								...state.brochureAttachment.uploadHistory,
								totalErrors: state.brochureAttachment.uploadHistory.totalErrors + 1,
							}
						}
				}
			}

			case BROCHURE_SUCCESS_FILE_UPLOAD:{
			const fileAttachmentArr = state.brochureAttachment.fileAttachments;
			const progressPercentage = (state.brochureAttachment.uploadHistoryFiles.length + 1) / state.brochureAttachment.uploadHistory.totalFiles * 100;
			const loadingIndex = fileAttachmentArr.findIndex((l) => l.loading);
			const fileAttachmentData = fileAttachmentArr.map((v,i) => i === loadingIndex ? payload : v);
				return {
					...state,
					brochureAttachment:{
						...state.brochureAttachment,
						uploadHistoryFiles: [...state.brochureAttachment.uploadHistoryFiles, payload],
						fileAttachments: fileAttachmentData,
						uploadProgress: progressPercentage,
						uploadHistory:{
							...state.brochureAttachment.uploadHistory,
							totalSuccess: state.brochureAttachment.uploadHistory.totalSuccess + 1
						}
					}
				}
			}

			case BROCHURE_TEMP_ACTIVE_TAB:{
				return {
					...state,
					isActiveBrochure: true,
				}
			}

			case BROCHURE_FILES_RESET_DATA: {
				return {
					...state,
					brochureAttachment: {
						...state.brochureAttachment,
						uploadingFiles: [],
						showUploadHistorySlider: false,
						uploadHistory:{
							totalFiles: 0,
							totalErrors: 0,
							totalSuccess: 0,
						},
						uploadProgress: 0,
						editNameDialog: false,
						previewFile: {
							fileMimeType: 'jpg',
							filePreviewToggle: false
						},
						uploadHistoryFiles: []
						}
					}
				}

			case BROCHURE_LISTING_COUNT:
				return {
					...state,
					listing: {
						...state.listing,
						totalBrochureCount: payload.totalBrochureCount,
						brochureData: payload.brochureData,
					}
				}
				
			case BROCHURE_LISTING_DATA: {
				const brochureAttachment = {
					...state.brochureAttachment,
					fileAttachments: payload.brochureData.map((cur,index) => {
						const ext = cur.menuUrl.substring(cur.menuUrl.lastIndexOf('.') + 1);
						return {
							...cur,
							uploaded: true,
							ext,
							fileId: cur.id,
							status: cur.approved === '0' ? 'Audit Pending' : null,
							url: cur.menuUrl.replace('http://', 'https://'),
							extension: ext,
							download: ext === 'pdf'
						};
					})
				}
				return {
					...state,
					listing:{
						...state.listing,
						totalBrochureCount: payload.totalBrochureCount,
						brochureData: payload.brochureData
					},
					brochureAttachment
				}
			}

		case TOGGLE_PRODUCT_CARD_SLIDER:
			return {
				...state,
				showAddPriceTag: Boolean(payload)
			}
		
		case PRICE_CARD_DATA_FETCHED:
			return {
				...state,
				pricecardData: payload
			}

		case TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER:
			return {
				...state,
				showOutDatedPriceTag: Boolean(payload)
			}

		case OUTDATED_PRICE_CARD_DATA_FETCHED:
			return {
				...state,
				outDatedPricecardData: payload
			}

		case TOGGLE_CATEGORY_MISSING_CARD_SLIDER:
			return {
				...state,
				showCategoryMissingCard: Boolean(payload)
			}

		case CATEGORY_MISSING_DATA_FETCHED:
			return {
				...state,
				categoryMissingCardData: payload
			}

		case TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST:
			return {
				...state,
				showCategoryMissingCardPersist: Boolean(payload)
			}
		
		case UPDATE_DESC_TYPE:
			const newState = {...state};
			const editProduct = newState?.editProduct;
			editProduct.descType = payload.descType;
			return newState;

		case TOGGLE_AI_CREATION_MODAL:
			return {
				...state,
				showAICreationModal: {
					...payload
				}
			}

		default:
			return state;
	}
};
